import React from "react"
import { shallowEqual, useSelector } from "react-redux";
import { FilterGroup } from "../../../../../../Common/components/FilterGroup";
import { SubscriptionTable } from "../../../../../../SubscriptionManagement/pages/SubscriptionsTable";

function Subscriptions(
    {
        match: {
            params: {
                userId,
                accountId
            }
        }
    }
) {
    const {accounts, profile} = useSelector(({ selectedUser }) => {
        const data = selectedUser?.data?.profile?.basic?.userId === userId ? selectedUser.data : null;
        return data;
    }, shallowEqual);

    return (
        <>
            <FilterGroup>
                <FilterGroup.Content>
                    {
                        ({ filters }) => {
                            return <SubscriptionTable userGroup={profile?.basic?.userGroup} userId={userId} accounts={accounts} />
                        }
                    }
                </FilterGroup.Content>
            </FilterGroup>
        </>
    )
}

export default Subscriptions